'use client';

import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { isNativePlatform } from 'src/utils/capacitor';
import { DemoScen } from './komponenter/DemoScen';
import { Hjälte } from './komponenter/Hjälte';
import { KomIgång } from './komponenter/KomIgång';
import { Sidfot } from './komponenter/Sidfot';
import { Sidhuvud } from './komponenter/Sidhuvud';

/**
 * Den publika startsidan. Byggd med appens egna MUI-tema och komponenter, så att
 * steget från landningssidan in i appen inte byter utseende.
 */
export function LandningView() {
    const router = useRouter();

    // Appskalet (Capacitor) laddar flinky.se — där ska appen öppnas, inte startsidan.
    useEffect(() => {
        if (isNativePlatform()) router.replace(paths.dashboard.root);
    }, [router]);

    return (
        <Box sx={{ minHeight: '100dvh', bgcolor: 'background.default', color: 'text.primary' }}>
            <Box component="a" href="#innehall" sx={visuelltDoldTillsFokus}>
                Hoppa till innehållet
            </Box>
            <Sidhuvud />
            <Box component="main" id="innehall">
                <Hjälte />
                <DemoScen />
                <KomIgång />
            </Box>
            <Sidfot />
        </Box>
    );
}

const visuelltDoldTillsFokus = {
    position: 'absolute',
    left: -9999,
    top: 8,
    zIndex: 2000,
    px: 2,
    py: 1,
    borderRadius: 1,
    bgcolor: 'background.paper',
    color: 'text.primary',
    boxShadow: 3,
    '&:focus': { left: 16 }
} as const;
